var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"player-container"}},[_c('div',{staticClass:"player"},[_c('iframe',{attrs:{"id":"hls-player","allow":"fullscreen","frameBorder":"0","src":_vm.$VUE_APP_HLS_PLAYER_URL_LIBRARY + '?url=' + _vm.url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }